import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import {
  ISignedDocument,
  ISignedDocumentResponse
} from "@wingspanhq/signed-documents/dist/lib/interfaces";
import { ContextItem } from "../../../../types";
import { WSQueryCache } from "@ws-react-query";
import { QUERY_SIGNED_DOCUMENT } from "../../../../../../query/signedDocuments/keys";

export const getSignedDocumentFromCache = (
  requirement: IRequirementResponse,
  contextItem: ContextItem
): ISignedDocumentResponse | undefined => {
  return WSQueryCache.getQueryData<ISignedDocument>([
    QUERY_SIGNED_DOCUMENT,
    requirement.dataSourceId
  ]);
};
